import React from 'react'

import BasicHeader from './basicHeader'
import css from './header.module.css'

const Header = ({ children, logo, title, subtitle }) => {
  return (
    <header className={css.header} role="banner" data-testid="header">
      <BasicHeader title={title} subtitle={subtitle} logo={logo} />
      {children}
    </header>
  )
}

export default Header
